import SignInComp from '../../components/signup/SignInComp.jsx'

export const LoginPage = () => {
	return <SignInComp />
}
